__turbopack_context__.v({
  "loadMoreTrigger": "reviews-client-module__aiQX6W__loadMoreTrigger",
  "loader": "reviews-client-module__aiQX6W__loader",
  "reviewsBento": "reviews-client-module__aiQX6W__reviewsBento",
  "reviewsContainer": "reviews-client-module__aiQX6W__reviewsContainer",
  "reviewsHeader": "reviews-client-module__aiQX6W__reviewsHeader",
  "reviewsPlaceholder": "reviews-client-module__aiQX6W__reviewsPlaceholder",
  "reviewsTitle": "reviews-client-module__aiQX6W__reviewsTitle",
  "root": "reviews-client-module__aiQX6W__root",
  "scrollTopButton": "reviews-client-module__aiQX6W__scrollTopButton",
  "spin": "reviews-client-module__aiQX6W__spin",
});
